// Generic /google-maps → flagship Colorado Springs Google Maps page (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/google-maps")({
  beforeLoad: () => {
    throw redirect({ to: "/colorado-springs-google-maps", statusCode: 301 });
  },
});
